import { z } from 'zod';

import { preflightApiClient } from '../api/client';

export type journalObjectType = z.infer<typeof journalObject>;

const journalObject = z.object({
  label: z.string(),
  slug: z.string(),
  id: z.number(),
});

export type getAllJournalSlugsForEndpointResType = z.infer<
  typeof getAllJournalSlugsForEndpointRes
>;

const getAllJournalSlugsForEndpointRes = z.object({
  journals: z.array(journalObject),
});

export async function getAllJournalSlugsForEndpoint({
  publisherSlug,
  journalSlug,
}: {
  publisherSlug: string;
  journalSlug?: string;
}) {
  return await preflightApiClient
    .get(`/journal/${publisherSlug}/search?query=${journalSlug || ''}`)
    .then(getAllJournalSlugsForEndpointRes.parse);
}
